'use strict';
import Tween from './Tween';

function getStyle(obj, sName) {
    return (obj.currentStyle || getComputedStyle(obj, false))[sName];
}

function move(obj, json, options) {
    options = options || {};
    options.time = options.time || 700;
    options.company = options.company || 'px';
    options.type = Tween[options.type] || Tween.linear;
    // console.log(options.type)
    var start = {};
    var dis = {};
    for (var name in json) {
        start[name] = parseFloat(getStyle(obj, name));
        if (isNaN(start[name])) {
            switch (name) {
                case 'top':
                    start[name] = obj.offsetTop;
                    break;
                case 'left':
                    start[name] = obj.offsetLeft;
                    break;
                case 'width':
                    start[name] = obj.offsetWidth;
                    break;
                case 'height':
                    start[name] = obj.offsetHeight;
                    break;
                case 'opacity':
                    start[name] = 1;
                    break;
                case 'borderWidth':
                    start[name] = 0;
                    break;
            }
        }
        dis[name] = json[name] - start[name];
    }
    var count = Math.floor(options.time / 30);
    var n = 0;
    clearInterval(obj.timer);
    obj.timer = setInterval(function() {
        n++;
        for (var name in json) {

            var cur = options.type(n * options.time / count, start[name], dis[name], options.time);
            if (name == 'opacity') {
                obj.style.opacity = cur;
                obj.style.filter = 'alpha(opacity:' + cur * 100 + ')';
            } else {
                obj.style[name] = parseInt(cur) ? (parseInt(cur) + options.company) : cur;
            }
        }
        if (n == count) {
            clearInterval(obj.timer);
            options.end && options.end();
        }
    }, 30);
}
export default move;